import { KeycloakConfig } from 'keycloak-js';
import { ClientConstants, LocalstorageConstants } from '@dss-libs/shared/type/common-types';
import { provideKeycloak } from 'keycloak-angular';
import { EnvironmentProviders } from '@angular/core';

export function provideKeycloakWithConfig(keycloakConfig: KeycloakConfig): EnvironmentProviders {
  function getClientId() {
    return window.localStorage.getItem(LocalstorageConstants.CLIENT_ID) || ClientConstants.DEFAULT_CLIENT_ID;
  }
  return provideKeycloak({
    config: {
      ...keycloakConfig,
      clientId: getClientId(),
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
    },
  });
}
